import izitoast from 'izitoast'

export const defaultIziToastConfig = {
  position: 'topRight',
  timeout: 3000
}

const questionDefaults = {
  position: 'center',
  timeout: 0,
  overlay: true
}

const mergeOptions = (options, values) => Object.assign(options, values)

const methods = {
  $_toast: null,
  question(message, title = '', options = {}) {
    options = Object.assign({}, questionDefaults, options)
    let rejector = null

    let questionPromise = new Promise((resolve, reject) => {
      rejector = () => reject(new Error('canceled'))
      options.buttons = [
        [
          '<button class="mr-2"><b>Yes</b></button>',
          (instance, toast) => {
            resolve(true)
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
          },
          true
        ],
        [
          '<button>No</button>',
          function(instance, toast) {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
          }
        ]
      ]
    })
    this.$_toast.question(mergeOptions(options, { message, title, onClosing: rejector }))
    return questionPromise
  },
  show(message, title = '', options = {}) {
    this.$_toast.show(mergeOptions(options, { message, title }))
  },
  hide(toast = null, options = {}) {
    this.$_toast.hide(toast, options)
  },
  progress(toast, options = {}, callback = () => {}) {
    this.$_toast.progress(toast, options, callback)
  },
  destroy() {
    this.$_toast.destroy()
  },
  info(message, title = '', options = {}) {
    this.$_toast.info(mergeOptions(options, { message, title }))
  },
  success(message, title = '', options = {}) {
    this.$_toast.success(mergeOptions(options, { message, title }))
  },
  warning(message, title = '', options = {}) {
    this.$_toast.warning(mergeOptions(options, { message, title }))
  },
  error(message, title = '', options = {}) {
    this.$_toast.error(mergeOptions(options, { message, title }))
  }
}

export default {
  install(Vue, options) {
    // if (Vue.prototype.$toast) {
    izitoast.settings(defaultIziToastConfig)
    methods.$_toast = izitoast
    // }
    Vue.prototype.$appToast = methods
  }
}
